import { render, staticRenderFns } from "./AdvantagesQuadrant.vue?vue&type=template&id=7b3ac6ca"
import script from "./AdvantagesQuadrant.vue?vue&type=script&lang=js"
export * from "./AdvantagesQuadrant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports